import { RxDatabase } from 'rxdb'
import { CustomerMetaData } from '@obeta/models/lib/models/Users/UserV2'

export const saveUserMeta = async (db: RxDatabase, sub: string) => {
  const splits = sub.split('-')
  const companyId = splits.shift()
  const userId = splits.join('-')

  const doc = await db.getLocal<CustomerMetaData>('usermeta')
  // purpose of the isLoggedIn flag is to boradcast this status to all tabs
  // that are opened, it will trigger fetching the latest token from SecureStorage,
  // so all tabs are in the same state
  await doc?.incrementalModify((doc) => {
    doc.isLoggedIn = true
    doc.companyId = companyId || ''
    doc.userId = userId
    return doc
  })
}
